import React, { Component } from 'react'
import { Link  } from 'react-router-dom'

import { getApiDatas, isAppMobile, urlToHost} from "../../utilities/FrontFunctions/AoxFrontFunctions"

import ObjProgressBarExpertise from '../inc/ObjProgressBarExpertise'
import ObjExpertiseBadge from '../inc/ObjExpertiseBadge'

class ObjExpertiseBrand extends Component {
	constructor() {
		super()
		this.state = {
		}
	}
	handleLinkFormation(e, brandId){
		e.preventDefault();
		getApiDatas(`/apiaox/Call/GetBrandTrainingPage?nBrandId=${brandId}`)
		.then((apiDatas) => { window.location.href =  urlToHost(apiDatas.BrandTrainingPage); })
	}

	render() {
		const { user, badges, userBadges } = this.props

		return (
			<div className={`obj_bloc_expertise ${user.Brand_CssClass}${this.state.active ? ' is-expanded' : ''}`} >
				<button className="obj_header_exp" onClick={ () => this.setState({active: !this.state.active}) }>{/* <!-- is-expanded --> */}	
					<h3 className="t_title">Mon Expertise <strong>{user.Brand_Name}</strong></h3>

					<div className="obj_progress-bar-expertise">
						<span>Formations suivies : <strong>{user.UserTrainingsOnLine_Completed} / {user.Brand_NbTrainingsOnLine}</strong></span>
						<ObjProgressBarExpertise step={user.UserTrainingsOnLine_Completed} stepstotal={user.Brand_NbTrainingsOnLine} />
					</div>

                    { !isAppMobile() &&
                        <div className="ctn_cta">
                            <Link onClick={(e) => this.handleLinkFormation(e, user.Brand_Id)} to="" className="obj_cta">
                                Je complète ma formation
                            </Link>
                        </div>
                    }
				</button>

				<div className='ctn_content'>
					<div className='ctn_row'>
						<div className="obj_points_exp">

							<div className='ctn_text'>
								<div className='obj_text'>
									<h3 className="t_title"><strong>Ma formation</strong></h3>
									<p className="t_desc">
                                        Vous avez suivi {user.UserTrainingsOnLine_Completed} formation{user.UserTrainingsOnLine_Completed > 1 ? 's' : ''}<br />
                                        sur les {user.Brand_NbTrainingsOnLine} proposées.
                                    </p>
								</div>
								<div className='ctn_aside'>
									<div className='obj_progress-number'>
										<span className='t_number'>{user.UserTrainingsOnLine_Completed}</span> <span className='t_number-total'>/{user.Brand_NbTrainingsOnLine}</span>
									</div>
								</div>
							</div>

							<div className="obj_progress-bar-expertise">
								<ObjProgressBarExpertise step={user.UserTrainingsOnLine_Completed} stepstotal={user.Brand_NbTrainingsOnLine} />
							</div>

                            { !isAppMobile() &&
                                <div className="ctn_cta">
                                    <Link onClick={(e) => this.handleLinkFormation(e, user.Brand_Id)} to="" className="obj_cta">
                                        Je complète ma formation
                                    </Link>
                                </div>
                            }

						</div>

						<div className="obj_recompences_exp">
							
							<h3 className="t_title"><strong>Mes badges</strong></h3>

							<div className="lst_items_exp">
                                {badges.map((badge, index) => (
                                    <ObjExpertiseBadge
                                        key={index}
                                        badge={badge}
                                        userBadge={userBadges.find(o => o.UserBadge_Badge_Id === badge.Badge_Id)}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
			</div>
		)
	}
}

export default ObjExpertiseBrand